"use client";

import { useTranslations } from "next-intl";
import { CustomDialog } from "@/components/custom/dialog";
import { environments } from "@/lib/config";
import { useRouter } from "next/navigation";

interface RegistrationCancelDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  onConfirm?: () => void;
}

export default function RegistrationCancelDialog({
  open,
  setOpen,
}: RegistrationCancelDialogProps) {
  const router = useRouter();
  const authServerUrl = environments.authServerUrl;
  const t = useTranslations("dialogs.registrationCancel");

  return (
    <CustomDialog
      open={open}
      onOpenChange={setOpen}
      title={t("title")}
      description={t("description")}
      classNameTitle="text-xl"
      size="xs"
      stopInteractOutside={false}
      cancelText={t("cancelText")}
      okText={t("okText")}
      okButtonVariant="destructive"
      onOkClick={() => router.push(authServerUrl ?? "/account/login")}
    />
  );
}
